var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd === undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses === undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
		if($('#siteinfo').length > 0) {
			$('#siteinfo').removeClass('hidden').addClass('sr-only');
		}
		$( document ).ready(function() {
			if($('span.ui-helper-hidden-accessible').length > 0) {
				$('span.ui-helper-hidden-accessible').attr('aria-atomic', true);
			}
		});

	}
};

site.content = {
	init: function() {
		site.content.blockquote();
		site.content.qn();
	},

	blockquote: function() {
		$('blockquote').has('cite').addClass('hasCite');
	},

	qn: function() {
		var $body = $('body');

		site.maxHeight.init('#qn .mmLevel1');

		$('#qnToggle').on('click touchstart', function (e) {
			e.stopPropagation();
			e.preventDefault();

			if (!$body.hasClass('qn-open')) {
				$body.addClass('qn-open');
			}
			else {
				site.content.qnClose();
			}

			$('body.qn-open').on('click touchstart', function (e) {
				site.content.qnClose();
			});
		});
	},

	qnClose: function() {
		var $body = $('body');
		$body.removeClass('qn-open').addClass('qn-closing')
		setTimeout(function() {
			$('body').removeClass('qn-closing');
		},300);

	},
};

site.study = {
	init: function() {
		if ($('.review').length > 1) {
			site.owl.init('.reviews .wrapper', {
				nav: false,
				loop: false,
				dots: true,
				items: 1
			});
		}
	}
};

site.readspeker = {
	init: function() {
		window.rsConf = {
			general: {usePost: true}
		};
		if($('#readspeaker_button1').length > 0) {
			site.readspeker.accordionFix();
		}
	},
	accordionFix: function() {
		var $accordions = $('.accordion');
		if (!$accordions.length) {
			return;
		}
		$accordions.removeClass('rs_preserve');

		document.addEventListener('DOMContentLoaded', ReadSpeaker.q(function() {
			var $current;
			rspkr.c.addEvent('onBeforeSync', function(type, id) {
				var element = $rs.get('#sync' + id),
					$parent = $(element.parentElement);

				if (!$current || $current[0] !== $parent[0]) {
					var $closedAccordion = $parent.parents('.accordion:not(.open)');
					if ($closedAccordion.length) {
						$closedAccordion.addClass('open');
					}
					$current = $parent;
				}
			});
		}), false);
	}
};

site.frontpage = {
	init: function() {
		site.sticky.box('body', 'scrolled', -120, 992);
	}
};

site.courses = {
	index: function() {
		if ($('.filtr-item').length === 0) return false;

		var filterizr = $('.courses', '#courseIndex').filterizr({
			animationDuration: 0,
			filterOutCss: {
				opacity: 0,
				display: 'none'
			},
			filterInCss: {
				opacity: 1,
				display: 'block'
			},
			layout: 'sameWidth',
		}),
		$body = $('body'),
		frontpage = $body.is('.frontpage');

		$('.filtr-button', '#courseIndex').click(function(e) {
			var $this = $(this);
			if (frontpage && $body.width() + 15 >= 992) {
				e.preventDefault();
			}
			let wasActive = $this.is('.filtr-active');

			$('.subFilters .filtr-active').removeClass('filtr-active');

			if ($this.is('.type')) {
				if (wasActive) {
					$body.removeClass('courses-open');
					$this.removeClass('filtr-active');
				}
				else {
					if (!$body.is('.courses-open')) {
						$body.addClass('courses-open');
					}
				}

				$('.filtr-button', $this.closest('ul')).removeClass('filtr-active');
				if ($body.is('.courses-open')) {
					$this.addClass('filtr-active');
				}

				$('.subFilters .type.active').removeClass('active');
				let hash = $this.data('hash').replace('#', '');
				const $subFilter = hash ? $('.subFilters .' + hash) : null;
				if ($subFilter) {
					if ($this.hasClass('filtr-active')) {
						$subFilter.addClass('active');
					}
				}
			}
			else {
				if (!wasActive) {
					$this.addClass('filtr-active');
				}

				//Remove subfilter key from url
				if (!$this.hasClass('filtr-active')) {
					let type = $this.data('type');
					filterizr.filterizr('filter', type);
					setTimeout(() => {
						window.location.hash = type
					},1);
				}
			}
		});

		$grunnamOpen = $('#courseIndex.grunnamOpen');
		if (frontpage && $body.width() + 15 >= 992 && $grunnamOpen.length > 0) {
			$(document).ready(
				function () {
					$('[data-filter="grunnnam"]').click()
				}
			);
		}

		$('input[type="text"]', '#courseIndex').keyup(function() {
			$('.filtr-button').removeClass('filtr-active');
		});

		if (!frontpage) {
			const hashParts = location.hash.replace('#', '').split('|');
			if (hashParts.length === 2) {
				$('a.type[data-filter="' + hashParts[0] + '"]').addClass('filtr-active');
				$('.subFilters .' + hashParts[0]).addClass('active');
			}
			else {
				$('a', '.filter-all').addClass('filtr-active');
			}
		}

		var hash = location.hash.slice(1);
		if (hash.length > 0) {
			$('a[href$="#' + hash + '"]').trigger('click');
		}
	}
};

site.databases = {
	init: function() {
		$('a', '.showMore').on('click', function(e) {
			e.preventDefault();
			$('body').removeClass('initFilter');
			var $this = $(this);
			$this.parent().get(0).remove();
		});
	}
};
site.exchange = {
	init: function() {
		var langMap = {
          en: {
            path: 'English',
            mods: {
              sSearch: "Search"
            }
          },
          is: {
            path: 'Icelandic',
            mods: {
              sSearch: "Leitaðu hér! Sláðu inn nám, deild eða háskóla"
            }
          }
        };

        function getLanguage() {
          var lang = $('html').attr('lang');
          var result = null;
          var path = '//cdn.datatables.net/plug-ins/1.10.13/i18n/';
          $.ajax({
            async: false,
            url: path + langMap[lang].path + '.json',
            success: function(obj) {
              result = $.extend({}, obj, langMap[lang].mods)
            }
          })
          return result
        }
		$('.filterTable').DataTable( {
			initComplete: function () {
				this.api().rows().every( function (i) {
					$(this.node()).removeAttr('role');
				});
				this.api().columns().every( function (i) {
					var column = this;
					var select = $('<select aria-label="' + this.context[0].nTHead.firstChild.cells[i].ariaLabel + '"><option value=""></option></select>')
						.appendTo($(column.header()))
						.on('change', function (e) {
							e.stopPropagation();
							var val = $.fn.dataTable.util.escapeRegex(
								$(this).val()
							);
							column
								.search( val ? '^'+val+'$' : '', true, false )
								.draw();
						})
						.on('click', function(e) {
							e.stopPropagation();
						});
					column.data().unique().sort().each( function ( d, j ) {
						select.append( '<option value="'+d+'">'+d+'</option>' )
					});
					select.wrapAll( "<span class='lmnt' />");
				});
			},

			language: getLanguage(),

			info: false,
			lengthChange: false,
			pageLength: 30
		});
	}
};

site.stickyHeader = {
	init: function() {
		var hash = location.hash;
		if (hash) {
			hash = '#' + hash.replace(/[^a-zA-Z 0-9]+/g,'');
		}
		if ($(hash).length > 0) {
			$(window).load(function () {
				site.stickyHeader.scroll(hash);
			});
		}

		$('a[href^=#]').bind('click', function(e) {
			var target = $(this).attr('href');
			if ($(target).length > 0 && !site.stickyHeader.isInViewport($(target))) {
				e.preventDefault();
				site.stickyHeader.scroll(target);
			}
		});
	},

	scroll: function(target) {
		var scrollToPosition = $(target).offset().top - $('#header').height() - 30;
		$('html').animate({'scrollTop': scrollToPosition}, 200, function () {
			window.location.hash = "" + target;
			$('html').animate({'scrollTop': scrollToPosition}, 0);
		});
	},

	isInViewport: function($elm) {
		var elmTop = $elm.offset().top,
			elmBottom = $elm.offset().top + $elm.outerHeight(),
			screenTop = $(window).scrollTop(),
			screenBottom = $(window).scrollTop() + window.innerHeight;
		return (screenBottom > elmTop) && (screenTop < elmBottom);
	}
};

site.ugla = {
	searchForm: function () {
		const input = $('.box_search :input');
		if (!input.length) {
			return;
		}
		input.focus(function () {
			$(this).siblings('label').css('opacity', 0);
		})
		.blur(function () {
			if ($(this).val().length == 0) {
				$(this).siblings('label').css('opacity', 1);
			}
		});
	}
};

site.calendar = {
	view: function() {
		var $body = $('body');
		$('.addtocalendar > a').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			$body.toggleClass('addtocal-open');
		});
		$body.on('click', function(e) {
			if ($body.is('.addtocal-open')) {
				$body.removeClass('addtocal-open');
			}
		});
	}
};

site.store = {
	init: function () {
		$('body').on('click', '#storeCart .showMore', function (e) {
			e.preventDefault();
			$('body').toggleClass('cart-open');

			$('body.cart-open').on('click', function (e) {
				if (!$(e.target).parents('#storeCart').length) {
					$('body').removeClass('cart-open');
				}
			});
		});

		//Checkout
		if ($('body').hasClass('checkout')) {
			$('#billing-billingSameAsShipping').change(function() {
				var $fieldset = $('#fieldset-billing').toggleClass('disabled');
				if ($fieldset.hasClass('disabled')) {
					$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
				}
				else {
					$fieldset.find('input:not(.checkbox)').attr('disabled', null);
				}
			}).change();

			$('ul.paymentTypeSelection li').click(function(){
				$(this).siblings().removeClass('selected');
				$(this).addClass('selected');
			});
		}
	}
};

store = window.store || {};
store.local = store.local || {};
store.local.onUpdateVariantData = function(variant) {
	var attributes = '';
	$.each(variant.attributes, function(attrIdx, attr) {
		attributes += attr + ' / ';
	});
	attributes = attributes.substr(0, attributes.length - 3);

	$('.product .attributes').html(attributes);
};

store.local.updateMiniCart = function() {
	$.get(store.url(store.action.cartMedium, ''), function (data) {
		$('.cartBoxMedium').replaceWith(data.html);
	}, 'json');
	$.get(store.url(store.action.cartBox, ''), function (data) {
		$('.miniCart').replaceWith(data.html);
	}, 'json');
};

store.local.onAddToCart = function() {
	store.local.updateMiniCart();
};

store.local.onCartIncrease = function() {
	store.local.updateMiniCart();
};

store.local.onCartDecrease = function() {
	store.local.updateMiniCart();
};

store.local.initAlbumImages = function() {
	site.owl.init('.product .albumImages', {
		loop: false,
		dots: false,
		nav: true,
		items: 4,
		navText: ["", ""],
		margin: 10,
		responsive: {
			0: {
				items: 2
			},
			480: {
				items: 4
			}
		}
	});

	$('ul.albumImages a').click(function(e) {
		e.preventDefault();
		$href = $(this).attr('href');
		$src = $(this).data('image');
		$image = $('.images .image');

		if ($src != $('img', $image).attr('src')) {
			$image.append('<div class="loading">')
			$('a', $image).attr("href", $href);
			$('img', $image).attr("src", $src).load(function() {
				$('.loading',$image).remove();
			});
		}
	});
};

store.local.onInitProduct = function() {
	//Wrap variention select in .lmnt, to style select arrow
	$('select', '.variantSelection').each(function() {
		var $this = $(this);
		if (!$this.parent().hasClass('lmnt')) {
			$this.wrap('<span class="lmnt selectWrap"/>');
		}
	});
};


// Run all the inits \o/
$(function() {
	// Init tabs
	$('div.tabs').tabs();
	$('div.tabs--vertical').tabs().addClass("ui-tabs-vertical ui-helper-clearfix");

	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.megamenu.init();
	site.accessibility.init();
	site.content.init();
	site.labelFocus.init();
	site.stickyHeader.init();
	site.store.init();
	site.readspeker.init();
	site.ugla.searchForm();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#page').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9 noprint"></div></div>');
	});


	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
	$('.share').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
